import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./BottomTab.css"; // Add your CSS styling here
import home from "../../assets/images/icon/home.svg";
import collection from "../../assets/images/icon/collection.svg";
import cart from "../../assets/images/icon/bcart.svg";
import wishlist from "../../assets/images/icon/bwishlist.svg";
import account from "../../assets/images/icon/account.svg";
import { CartContext } from "../../Utils/CartContext";
import { WishlistContext } from "../../Utils/WishlistContext";
import SecureLS from "secure-ls";

const BottomTab = () => {
  const location = useLocation();
  const { cartCount } = useContext(CartContext);
  const { wishlistCount } = useContext(WishlistContext);
  const ls = new SecureLS({ encodingType: 'aes' });

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    // ls.removeAll();
    // Retrieve the stored email and name using SecureLS
    const email = ls.get('userEmail');
    const name = ls.get('userName');

    if (email && name) {
      setIsLoggedIn(true);
      setUserName(name);
    }
  }, []);

  // Define the mapping of paths to icons
  const navItems = [
    { path: "/", icon: home, alt: "home", title: 'Home' },
    { path: "/categories", icon: collection, alt: "categories", title: 'Categories' },
    {
      path: "/cart",
      icon: cart,
      alt: "cart",
      title: 'Cart',
      count: cartCount, // Add cartCount to the cart item
    },
    {
      path: isLoggedIn ? "/wishlist" : '/auth/login?wishlist',
      icon: wishlist,
      alt: "wishlist",
      title: 'Wishlist',
      count: wishlistCount, // Add wishlistCount to the wishlist item
    },
    { path: isLoggedIn ? "/account" : '/auth/login?account', icon: account, alt: "account", title: 'Account' },
  ];

  // Check if the current path matches any defined paths
  const isActive = (path) => {
    const fullPath = `${location.pathname}${location.search}`;
    return path === fullPath;
  };
  return (
    <div className="floater d-lg-none d-flex shadow">
      {navItems.map((item, index) => (
        <Link
          to={item.path}
          key={index}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <div
            className={`floater-btn ${isActive(item.path) ? "active" : ""}`}
          >
            <div className="icon-container">
              <img
                src={item.icon}
                alt={item.alt}
                style={{ width: "26px", height: "26px" }}
              />
              {/* Display badge if count is present and greater than 0 */}
              {item.count > 0 && (
                <span className="CountBadge">{item.count}</span>
              )}
            </div>
          </div>
          {/* <p className="text-center mb-0" style={{fontSize:'10px'}}>{item.title}</p> */}
        </Link>
      ))}
    </div>
  );
};

export default BottomTab;
